
    import { defineComponent } from 'vue';
    import { getModule } from 'vuex-module-decorators';
    import SignageLayouts from '../../components/signage/SignageLayouts.vue';
    import TierLimit from '../../components/TierLimit.vue';
    import TierState, { ITierState } from '../../store/modules/tier';

    let tierState = {} as ITierState;

    export default defineComponent({
        name: 'Signage Layouts',
        data() {
            return {
            }
        },

        components: {
            SignageLayouts,
            TierLimit
        },

        computed: {
            showTierCallout(): boolean {
                if(!tierState.orgTier.digitalSignageEnabled) {
                    return true;
                }
                return false;
            }
        },   

        async created () {
            tierState = getModule(TierState);

            await tierState.fetchTier();
        }
    });
